<template>
	<div>
		<div class="btn-box flex pb-24 flex-align-center">
			<el-button @click="addTag">添加标签</el-button>
			<p class="yx-color-pure-1 ml-16 fz-14">
				共
				<span class="yx-color-primary">{{ total }}</span>
				个标签
			</p>
		</div>
		<multi-table
			ref="multiTable"
			:columns="columns"
			@gePartnerList="tabGetList"
			:list="list"
			:page="pageInfo"
			:total="total"
			v-loading="loading"
			:key="activeName"
		>
			<empty slot="empty"></empty>
		</multi-table>

		<add-tag ref="addTag" @refreshList="refreshList" :type="activeName"></add-tag>
		<del-dialog ref="del" @refreshList="refreshList" :type="activeName"></del-dialog>
	</div>
</template>
<script>
import empty from '@/views/common/empty/index.vue';
import { tagsList } from '@/api/shopManage';
import AddTag from './components/addTag.vue';
import delDialog from './components/del.vue';
import getColums from './columns';
export default {
	components: {
		empty,
		AddTag,
		delDialog,
	},
	props: {
		activeName: {
			type: [Number, String],
			default: '0',
		},
	},
	watch: {
		activeName() {
			this.columns = getColums(this.activeName);
			console.log(this.columns, 'this.columns');
		},
	},

	data() {
		return {
			list: [],
			isSearch: false,
			loading: false,
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			total: 0,
			params: {},
			columns: [],
		};
	},
	created() {
		this.columns = getColums(this.activeName);
		this.getList();
	},
	methods: {
		async getList(isSearch) {
			this.isSearch = Boolean(isSearch);
			this.loading = true;
			const {
				code,
				data: { list = [], page = {} },
			} = await tagsList({ ...this.pageInfo, ...this.params, type: this.activeName });
			if (code !== 0) return;
			this.loading = false;
			this.total = `${page.item_total}`;
			this.list = list.map(item => ({
				...item,
				operations: this.getButtons(item),
			}));
		},
		addTag() {
			this.$refs.addTag.show('添加标签', 'add');
		},
		edit(row) {
			this.$refs.addTag.show('编辑标签', 'edit', row);
		},
		del({ id }) {
			this.$refs.del.show(id);
		},
		tabGetList(obj) {
			const { page_size, page_index } = obj;
			this.pageInfo.page_size = page_size;
			this.pageInfo.page_index = page_index;
			this.getList();
		},
		getButtons() {
			const arr = [];
			arr.push(
				{
					label: '编辑',
					type: 'text',
					classtype: 2,
					isShow: true,
					click: row => this.edit(row),
				},
				{
					label: '删除',
					type: 'text',
					classtype: 2,
					isShow: true,
					click: row => this.del(row),
				},
			);
			return arr;
		},
		refreshList() {
			this.getList();
		},
		onSubmit(val) {
			this.pageInfo.page_index = 1;
			this.params = val;
			this.getList(1);
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .table-btns {
	display: flex;
}
/deep/ button {
	margin-right: 12px;
}
</style>
